import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=6c679773"
import script from "./TabButton.vue?vue&type=script&lang=js"
export * from "./TabButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports